import React, { ComponentProps, ForwardedRef, forwardRef, PropsWithChildren } from 'react'

import { bemJoin, classNames } from '@app/lib/bem'

import './IconButton.scss'

export type IconButtonProps = ComponentProps<'button'> & {
  'aria-label': string
  size?: 'xs' | 'sm' | 'md' | 'lm' | 'lg'
  color?: 'primary' | 'secondary' | 'neutral'
  variant?: 'outlined' | 'ghost' | 'solid'
  shape?: 'circle' | 'square' | 'rectangle'
}

const b = bemJoin('icon-button')

export const IconButton = forwardRef(
  (
    {
      children,
      className,
      size = 'md',
      color = 'neutral',
      variant = 'ghost',
      shape = 'square',
      ...props
    }: PropsWithChildren<IconButtonProps>,
    forwardedRef: ForwardedRef<HTMLButtonElement>
  ) => {
    return (
      <button
        ref={forwardedRef}
        type='button'
        className={classNames(
          b({
            [size]: true,
            [color]: true,
            [variant]: true,
            [shape]: true
          }),
          className
        )}
        {...props}
      >
        {children}
      </button>
    )
  }
)
